import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

/**
 * 📅 Página de Eventos del Calendario
 */
const CalendarEvents = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
          Eventos del Calendario
        </h2>

        <p className="text-gray-600 dark:text-gray-400">
          Aquí se mostrarán los eventos programados, reuniones, recordatorios y
          demás actividades registradas en el sistema.
        </p>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default CalendarEvents;
